import React, { useEffect, useMemo } from 'react';
import CustomSelect from '../../components/CustomSelect';
import {
  useGetCustomSelectButtonElement,
  useSetStringDefaultValue,
} from '../../hooks/init';
import { SingleCommonType } from '../../types';
import { sentimentEditingStatusPlaceholder } from '../../constants/placeholder';
import { commonBackInfo } from '../../utils';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import { useIntl } from 'umi';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
import { sentimentEditStatusOptions } from '../../constants/sentimentEditStatus';
import './index.scss';

export default function SentimentEditStatusSelect({
  onChange,
  defaultValue,
  defaultKey,
  filterValue,
  lang,
}: SingleCommonType) {
  const { formatOptionsMessage } = useLanguage();

  const {
    value: sentimentEditStatusSelects,
    setValue: setSentimentEditStatusSelects,
    diffClassName,
  } = useSetStringDefaultValue({
    defaultValue,
    filterValue,
    defaultKey: 'sentiment_edit_status',
    initValue: '99999',
  });

  const selectValue = useMemo(() => {
    if (sentimentEditStatusSelects === '99999')
      return ['manual_edited', 'unedited'];
    if (sentimentEditStatusSelects === '-99999') return [];
    return [sentimentEditStatusSelects];
  }, [sentimentEditStatusSelects]);

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();
  const { formatMessage } = useIntl();
  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'sentiment_edit_status',
      commonBackInfo(
        {
          sentiment_edit_status: ['-99999', '99999'].includes(
            sentimentEditStatusSelects,
          )
            ? ''
            : sentimentEditStatusSelects,
        },
        { [defaultKey]: text },
        { needChangeEntity: true, isAll },
      ),
    );
  }, [sentimentEditStatusSelects, formatMessage]);

  return (
    <div className={`sentiment-edit-status-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        matchButtonWidth={false}
        placeholderText={sentimentEditingStatusPlaceholder[lang]}
        onClear={() => setSentimentEditStatusSelects('99999')}
        selectOptionsInfo={[
          selectValue,
          (value: Array<string>) => {
            if (value.length === sentimentEditStatusOptions.length) {
              setSentimentEditStatusSelects('99999');
            } else if (value.length === 0) {
              setSentimentEditStatusSelects('-99999');
            } else {
              setSentimentEditStatusSelects(value[0]);
            }
          },
        ]}
        options={formatOptionsMessage(sentimentEditStatusOptions)}
        pointKey={FilterButtonPoint.sentimentEditStatus}
      ></CustomSelect>
    </div>
  );
}
